import { render, staticRenderFns } from "./marketDepartDataStatistic.vue?vue&type=template&id=f90c70d4&scoped=true"
import script from "./marketDepartDataStatistic.vue?vue&type=script&lang=ts"
export * from "./marketDepartDataStatistic.vue?vue&type=script&lang=ts"
import style0 from "./marketDepartDataStatistic.vue?vue&type=style&index=0&id=f90c70d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c70d4",
  null
  
)

export default component.exports